"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _class, _temp;

var Article = (_class = (_temp =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Article, _Activity);

  function Article() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Article);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Article)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this._articleTimer = null;
    return _this;
  }

  babelHelpers.createClass(Article, [{
    key: "setup",
    value: function setup() {
      var _this2 = this;

      this.addEventListener('startedActivity', this._articleActivityStarted);
      this.addEventListener('timerExpired', function () {
        return _this2.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this2.activityComplete();
      });
      this.addEventListener('unload', function () {
        if (_this2._articleTimer) clearTimeout(_this2._articleTimer);
        $(window).off('resize.article');
      });
      $(window).on('resize.article', this._articleResizeHelper);
      this.startActivity();
      if (this.readOnly) this.activityComplete();
    }
  }, {
    key: "_articleActivityStarted",
    value: function _articleActivityStarted(event) {
      this.showActivityTitle();

      if (!this.readOnly) {
        if (event.activity.endTime) {
          this.startTimer(new Date(event.activity.endTime).getTime() - new Date(event.activity.startTime).getTime(), true);
        } else {
          this.startTimer(10 * 1000, true);
        }
      }
    }
  }, {
    key: "_articleResizeHelper",
    value: function _articleResizeHelper() {
      var _this3 = this;

      if (this._articleTimer) clearTimeout(this._articleTimer);
      this._articleTimer = setTimeout(function () {
        return _this3.trigger('viewChanged');
      }, 100);
    }
  }]);
  return Article;
}(_base.default), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_articleActivityStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_articleActivityStarted"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_articleResizeHelper", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_articleResizeHelper"), _class.prototype)), _class);
exports.default = Article;